import { Flex } from 'mymoria-ui/components';
import { css, mq, styled } from 'mymoria-ui';
import { useScrollDirection } from 'mymoria-ui/hooks';
import { Col, Grid, Heading, Row, Text } from 'mymoria-ui/components';
import React, { FunctionComponent } from 'react';

interface Props {
  backgroundColor?: string;
  title?: string;
  meta?: string;
  className?: string;
}

const StyledSection = styled.div<Props>(
  ({ backgroundColor }) =>
    `
    margin-top: 1rem;
    width: 100%;
    height: 100%;
 
    padding: 2rem 0;
    position: relative;
    background-color: ${backgroundColor};
  `,
);

interface StyledProps {
  isTop?: boolean;
  visible?: boolean;
}

const Header = styled(Row)<Pick<Props, 'backgroundColor'> & StyledProps>(
  ({ backgroundColor }) => css`
    position: sticky;
    margin-bottom: 2rem;
    background-color: ${backgroundColor};
    z-index: 10;
    top: 0;
  `,
);

const HeaderCol = styled(Col)<StyledProps>(
  ({ isTop }) => css`
    z-index: 99;
    display: flex !important;
    justify-content: space-between;

    h1 {
      display: inline-block;
    }

    h2 {
      margin: 1rem 0;
    }

    span {
      ${mq({
        margin: ['0.5rem 0', '0 0 0 1rem'],
      })};
    }

    ${mq({
      flexWrap: ['wrap', 'nowrap'],
      flexDirection: ['column', 'row'],
      alignItems: ['end', 'center'],
      padding: ['0 1rem', isTop ? '2rem 0.5rem 0' : '0 0.5rem', '0 0.5rem'],
    })};
  `,
);

const StyledGrid = styled(Grid)(
  mq({
    padding: ['0', '0 8px', '0 16px', '0 24px'],
  }),
);

const MetaText = styled(Text)(({ theme: { colors } }) =>
  mq({
    textAlign: ['left', 'right'],
    color: colors.lighterBlack,
  }),
);

const Section: FunctionComponent<Props> = ({
  backgroundColor,
  children,
  title,
  meta,
  className,
}) => {
  const { isTop } = useScrollDirection({ thresholdPixels: 80 });

  return (
    <StyledSection backgroundColor={backgroundColor} className={className}>
      <StyledGrid>
        <Header flexWrap="wrap" backgroundColor={backgroundColor} isTop={isTop}>
          <HeaderCol width={1} isTop={isTop}>
            <div>
              {isTop ? (
                <>
                  <Heading.Heading1>{title}</Heading.Heading1>
                </>
              ) : (
                <Heading.Heading2>{title}</Heading.Heading2>
              )}
            </div>
            {meta && <MetaText>{meta}</MetaText>}
          </HeaderCol>
        </Header>
        <Flex>{children}</Flex>
      </StyledGrid>
    </StyledSection>
  );
};

Section.defaultProps = {
  backgroundColor: 'rgba(243, 243, 243,0.95)',
  title: '',
  meta: '',
};

export default Section;
